export default __webpack_public_path__ + "static/media/checkmark-low.79110be8.svg";